import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { stationInfoGuard } from '../shared/guards/can-activate-station-info.guard';

const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    loadChildren: () => import('./start-page/start-page.module').then(m => m.StartPageModule),
  },
  {
    path: 'pay/',
    pathMatch: 'full',
    loadChildren: () => import('./start-page/start-page.module').then(m => m.StartPageModule),
  },
  {
    path: 'pay',
    pathMatch: 'full',
    loadChildren: () => import('./start-page/start-page.module').then(m => m.StartPageModule),
  },
  {
    path: 'payTest/',
    pathMatch: 'full',
    loadChildren: () => import('./start-page/start-page.module').then(m => m.StartPageModule),
  },
  {
    path: 'payTest',
    pathMatch: 'full',
    loadChildren: () => import('./start-page/start-page.module').then(m => m.StartPageModule),
  },
  {
    path: 'terms/:cp-uuid',
    pathMatch: 'full',
    loadChildren: () =>
      import('./terms-conditions/terms-and-conditions.module').then(
        m => m.TermsAndConditionsModule
      ),
  },
  {
    path: 'chargePort/:id',
    pathMatch: 'full',
    loadChildren: () => import('./start-page/start-page.module').then(m => m.StartPageModule),
  },
  {
    path: 'nearby-stations',
    pathMatch: 'full',
    loadChildren: () =>
      import('./nearby-stations/nearby-stations.module').then(m => m.NearbyStationsModule),
  },
  {
    path: 'express-payment/:id',
    pathMatch: 'prefix',
    loadChildren: () =>
      import('./express-payment/express-payment.module').then(m => m.ExpressPaymentModule),
    canActivate: [stationInfoGuard],
  },
  {
    path: 'prepare-payment/:id',
    pathMatch: 'full',
    loadChildren: () =>
      import('./prepare-payment/prepare-payment.module').then(m => m.PreparePaymentModule),
    canActivate: [stationInfoGuard],
  },
  {
    path: 'cookiesAndPixel',
    pathMatch: 'full',
    loadChildren: () =>
      import('./cookies-and-pixel/cookies-and-pixel.module').then(m => m.CookiesAndPixelModule),
  },
  { path: '**', redirectTo: '/' },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ComponentsRoutingModule {}
